import { FC } from 'react';

import { GiftSellerTabbedPage } from '../components/GiftSellerTabbedPage';
import { GiftEventLogPage } from './GiftEventLogPage';
import { GiftOrderAnalysisPage } from './GiftOrderAnalysisPage';

/**
 * 데이터 분석 + 이벤트 로그를 한 메뉴로 (관리자 전용).
 * 데이터 분석의 내부 탭은 state라 ?tab= 과 충돌하지 않는다.
 * 구 경로 /event-log 는 라우터에서 탭으로 넘긴다.
 */
export const GiftAnalysisHubPage: FC = function GiftAnalysisHubPage() {
  return (
    <GiftSellerTabbedPage
      tabs={[
        { key: 'analysis', label: '데이터 분석', element: <GiftOrderAnalysisPage /> },
        { key: 'event-log', label: '이벤트 로그', element: <GiftEventLogPage /> },
      ]}
    />
  );
};
